import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "social-icons" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "albums" }
const _hoisted_17 = ["title", "name"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = {
  key: 0,
  class: "popup"
}
const _hoisted_20 = ["title", "name"]
const _hoisted_21 = {
  key: 0,
  class: "comma"
}
const _hoisted_22 = { class: "artist-popup" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = ["href"]
const _hoisted_28 = ["href"]
const _hoisted_29 = ["href"]
const _hoisted_30 = ["href"]
const _hoisted_31 = ["href"]
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = ["href"]
const _hoisted_35 = ["href"]
const _hoisted_36 = ["href"]
const _hoisted_37 = ["href"]
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  key: 1,
  class: "popup"
}
const _hoisted_40 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "profile" }, [
      _createElementVNode("img", {
        src: "src/img/portrait-new.jpg",
        alt: "Profile Picture",
        class: "profile-pic"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        title: "Spotify",
        href: _ctx.UNDEFIANT.spotify,
        className: 'icon-button spotify'
      }, [
        _createVNode(_component_Icon, { icon: 'spotify' })
      ], 8, _hoisted_3),
      _createElementVNode("a", {
        title: "Apple Music",
        href: _ctx.UNDEFIANT.appleMusic,
        className: 'icon-button apple-music'
      }, [
        _createVNode(_component_Icon, { icon: 'apple-music' })
      ], 8, _hoisted_4),
      _createElementVNode("a", {
        title: "iTunes",
        href: _ctx.UNDEFIANT.itunes,
        className: 'icon-button itunes'
      }, [
        _createVNode(_component_Icon, { icon: 'itunes' })
      ], 8, _hoisted_5),
      _createElementVNode("a", {
        title: "Instagram",
        href: _ctx.UNDEFIANT.instagram,
        className: 'icon-button instagram'
      }, [
        _createVNode(_component_Icon, { icon: 'instagram' })
      ], 8, _hoisted_6),
      _createElementVNode("a", {
        title: "YouTube",
        href: _ctx.UNDEFIANT.youtube,
        className: 'icon-button youtube'
      }, [
        _createVNode(_component_Icon, { icon: 'youtube' })
      ], 8, _hoisted_7),
      _createElementVNode("a", {
        title: "YouTube Music",
        href: _ctx.UNDEFIANT.youtubeMusic,
        className: 'icon-button youtube-music'
      }, [
        _createVNode(_component_Icon, { icon: 'youtube-music' })
      ], 8, _hoisted_8),
      _createElementVNode("a", {
        title: "SoundCloud",
        href: _ctx.UNDEFIANT.soundCloud,
        className: 'icon-button soundcloud'
      }, [
        _createVNode(_component_Icon, { icon: 'soundcloud' })
      ], 8, _hoisted_9),
      _createElementVNode("a", {
        title: "Amazon Music",
        href: _ctx.UNDEFIANT.amazonMusic,
        className: 'icon-button amazon-music'
      }, [
        _createVNode(_component_Icon, { icon: 'amazon-music' })
      ], 8, _hoisted_10),
      _createElementVNode("a", {
        title: "Deezer",
        href: _ctx.UNDEFIANT.deezer,
        className: 'icon-button deezer'
      }, [
        _createVNode(_component_Icon, { icon: 'deezer' })
      ], 8, _hoisted_11),
      _createElementVNode("a", {
        title: "Hardtunes",
        href: _ctx.UNDEFIANT.hardtunes,
        className: 'icon-button hardtunes'
      }, [
        _createVNode(_component_Icon, { icon: 'hardtunes' })
      ], 8, _hoisted_12),
      _createElementVNode("a", {
        title: "Hardstyle.com",
        href: _ctx.UNDEFIANT.hardstylecom,
        className: 'icon-button hardstyle-com'
      }, [
        _createVNode(_component_Icon, { icon: 'hardstyle-com' })
      ], 8, _hoisted_13),
      _createElementVNode("a", {
        title: "Beatport",
        href: _ctx.UNDEFIANT.beatport,
        className: 'icon-button beatport'
      }, [
        _createVNode(_component_Icon, { icon: 'beatport' })
      ], 8, _hoisted_14),
      _createElementVNode("a", {
        title: "Facebook",
        href: _ctx.UNDEFIANT.facebook,
        className: 'icon-button facebook'
      }, [
        _createVNode(_component_Icon, { icon: 'facebook' })
      ], 8, _hoisted_15)
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RELEASES, (release, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "album",
          key: index,
          title: release.name,
          name: release.name
        }, [
          _createElementVNode("img", {
            src: 'src/img/covers/'+release.name.replaceAll(' ', '-')+'.jpg',
            alt: release.name
          }, null, 8, _hoisted_18),
          (!_ctx.showLinks)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("strong", null, _toDisplayString(release.name), 1),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                _cache[2] || (_cache[2] = _createTextVNode(" Artist: ")),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(release.artists, (artist, index2) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "artist",
                    key: index2,
                    title: artist.name,
                    name: artist.name
                  }, [
                    _createTextVNode(_toDisplayString(artist.name), 1),
                    (index2 < release.artists.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, ", "))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_22, [
                      _createTextVNode(_toDisplayString(artist.name) + " socials", 1),
                      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                      (artist.spotify)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            title: "Spotify",
                            class: "icon-button spotify",
                            href: artist.spotify
                          }, [
                            _createVNode(_component_Icon, { icon: 'spotify' })
                          ], 8, _hoisted_23))
                        : _createCommentVNode("", true),
                      (artist.appleMusic)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            title: "Apple Music",
                            class: "icon-button apple-music",
                            href: artist.appleMusic
                          }, [
                            _createVNode(_component_Icon, { icon: 'apple-music' })
                          ], 8, _hoisted_24))
                        : _createCommentVNode("", true),
                      (artist.instagram)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            title: "Instagram",
                            class: "icon-button instagram",
                            href: artist.instagram
                          }, [
                            _createVNode(_component_Icon, { icon: 'instagram' })
                          ], 8, _hoisted_25))
                        : _createCommentVNode("", true),
                      (artist.youtube)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 3,
                            title: "YouTube",
                            class: "icon-button youtube",
                            href: artist.youtube
                          }, [
                            _createVNode(_component_Icon, { icon: 'youtube' })
                          ], 8, _hoisted_26))
                        : _createCommentVNode("", true),
                      (artist.soundCloud)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 4,
                            title: "SoundCloud",
                            class: "icon-button soundcloud",
                            href: artist.soundCloud
                          }, [
                            _createVNode(_component_Icon, { icon: 'soundcloud' })
                          ], 8, _hoisted_27))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_20))
                }), 128)),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" Label: " + _toDisplayString(release.recordLabel), 1),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" Released: " + _toDisplayString(release.releaseDate.toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' })), 1),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                (release.spotify)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      title: "Spotify",
                      class: "icon-button spotify",
                      href: release.spotify
                    }, [
                      _createVNode(_component_Icon, { icon: 'spotify' })
                    ], 8, _hoisted_28))
                  : _createCommentVNode("", true),
                (release.appleMusic)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      title: "Apple Music",
                      class: "icon-button apple-music",
                      href: release.appleMusic
                    }, [
                      _createVNode(_component_Icon, { icon: 'apple-music' })
                    ], 8, _hoisted_29))
                  : _createCommentVNode("", true),
                (release.itunes)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      title: "iTunes",
                      class: "icon-button itunes",
                      href: release.itunes
                    }, [
                      _createVNode(_component_Icon, { icon: 'itunes' })
                    ], 8, _hoisted_30))
                  : _createCommentVNode("", true),
                (release.youtube)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      title: "YouTube",
                      class: "icon-button youtube",
                      href: release.youtube
                    }, [
                      _createVNode(_component_Icon, { icon: 'youtube' })
                    ], 8, _hoisted_31))
                  : _createCommentVNode("", true),
                (release.youtubeMusic)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 4,
                      title: "YouTube Music",
                      class: "icon-button youtube-music",
                      href: release.youtubeMusic
                    }, [
                      _createVNode(_component_Icon, { icon: 'youtube-music' })
                    ], 8, _hoisted_32))
                  : _createCommentVNode("", true),
                (release.soundCloud)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 5,
                      title: "SoundCloud",
                      class: "icon-button soundcloud",
                      href: release.soundCloud
                    }, [
                      _createVNode(_component_Icon, { icon: 'soundcloud' })
                    ], 8, _hoisted_33))
                  : _createCommentVNode("", true),
                (release.amazonMusic)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 6,
                      title: "Amazon Music",
                      class: "icon-button amazon-music",
                      href: release.amazonMusic
                    }, [
                      _createVNode(_component_Icon, { icon: 'amazon-music' })
                    ], 8, _hoisted_34))
                  : _createCommentVNode("", true),
                (release.deezer)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 7,
                      title: "Deezer",
                      class: "icon-button deezer",
                      href: release.deezer
                    }, [
                      _createVNode(_component_Icon, { icon: 'deezer' })
                    ], 8, _hoisted_35))
                  : _createCommentVNode("", true),
                (release.hardtunes)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 8,
                      title: "Hardtunes",
                      class: "icon-button hardtunes",
                      href: release.hardtunes
                    }, [
                      _createVNode(_component_Icon, { icon: 'hardtunes' })
                    ], 8, _hoisted_36))
                  : _createCommentVNode("", true),
                (release.hardstylecom)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 9,
                      title: "Hardstyle.com",
                      class: "icon-button hardstyle-com",
                      href: release.hardstylecom
                    }, [
                      _createVNode(_component_Icon, { icon: 'hardstyle-com' })
                    ], 8, _hoisted_37))
                  : _createCommentVNode("", true),
                (release.beatport)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 10,
                      title: "Beatport",
                      class: "icon-button beatport",
                      href: release.beatport
                    }, [
                      _createVNode(_component_Icon, { icon: 'beatport' })
                    ], 8, _hoisted_38))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("a", {
                  href: '/src/releases/'+release.wavLink
                }, "Download", 8, _hoisted_40)
              ]))
        ], 8, _hoisted_17))
      }), 128))
    ])
  ]))
}